import { TicketNotFound } from 'assets/images/svg';
import NavigationEnum from 'common/navigation';
import Stack from 'components/commons/stack';
import Text from 'components/commons/text';
import Button from 'components/elements/button';
import Link from 'next/link';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

interface Props {
  type: 'active' | 'pending' | 'history' | 'refund';
}

export default function BookingEmptyView(props: Props) {
  const { t } = useTranslation();

  const linkStyles: React.CSSProperties = {
    textDecoration: 'none',
  };
  return (
    <Stack alignItems="center" justify="center" gap="md">
      <TicketNotFound />
      <Text align="center" variant="headline5" weight="bold">
        {t('booking:booking_does_not_exist')}
      </Text>
      <Text align="center" variant="body4">
        {t(`booking:you_dont_have_${props.type}_booking`)}
      </Text>
      <Text align="center" variant="body4">
        {t('booking:please_make_a_booking')}
      </Text>

      <Link href={NavigationEnum.home} passHref style={linkStyles}>
        <Button>{t('common:order_now')}</Button>
      </Link>
    </Stack>
  );
}
